const baseURL = "https://api.axia-monitoring.com"; //process.env.VUE_APP_API_URL;

async function checkAdminStatus() {
  const url = `${baseURL}/api/is_admin`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Error al verificar si el usuario es admin.");
  }

  const data = await response.json();
  return data.is_admin;
}

export default {
  async getAllDevices() {
    const url = `${baseURL}/api/devices`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }
    const data = await response.json();
    return data.data; // Accedemos al arreglo de dispositivos
  },

  async getFamilies() {
    const url = `${baseURL}/api/families`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }
    const data = await response.json();
    return data; // Accedemos al arreglo de dispositivos
  },

  async getDevicesInBounds(minLat, minLon, maxLat, maxLon) {
    const url = `${baseURL}/api/devices_in_bounds?minlat=${minLat}&minlon=${minLon}&maxlat=${maxLat}&maxlon=${maxLon}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }
    const data = await response.json();
    return data.data; // Accedemos al arreglo de dispositivos
  },

  async getConteoDispositivos() {
    const url = `${baseURL}/api/contar_dispositivos`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }
    const data = await response.json();
    return data; // Accedemos al arreglo de dispositivos
  },

  async login(username, password) {
    const url = `${baseURL}/api/login`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.statusText}`);
      }

      const status = response.status;
      const data = await response.json();
      return { status, data }; // data debe incluir { user, message } al iniciar sesión correctamente
    } catch (error) {
      console.error("Error al intentar iniciar sesión:", error);
      throw error;
    }
  },

  async validateToken() {
    const url = `${baseURL}/api/validate_token`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    return response;
  },

  async logout() {
    const url = `${baseURL}/api/logout`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }

    return response;
  },

  async getTableData(
    page,
    perPage,
    search = "",
    apodoLector = "",
    timestamp = "",
    estado = ""
  ) {
    const url = new URL(`${baseURL}/api/get_table_data`);
    url.searchParams.append("page", page);
    url.searchParams.append("per_page", perPage);
    if (search && search.trim().length > 0) {
      url.searchParams.append("search", search.trim());
    }
    if (apodoLector && apodoLector.trim().length > 0) {
      url.searchParams.append("apodoLector", apodoLector.trim());
    }
    if (timestamp && timestamp.trim().length > 0) {
      url.searchParams.append("timestamp", timestamp.trim());
    }
    if (estado && estado.trim().length > 0) {
      url.searchParams.append("estado", estado.trim());
    }

    console.log("URL de la petición:", url.toString());

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(
        `Error en la petición: ${response.status} - ${errorMessage}`
      );
    }
    return await response.json();
  },

  async getManuales() {
    const url = `${baseURL}/api/manuales`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(
        `Error al obtener el menú de manuales: ${response.statusText}`
      );
    }
    return await response.json();
  },

  async getFileUrl(docId) {
    const url = `${baseURL}/api/manuales/file/${encodeURIComponent(docId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(
        `Error al obtener la URL del PDF: ${response.statusText}`
      );
    }
    return await response.json();
  },

  async deleteDevices(deviceIds) {
    const url = `${baseURL}/api/delete_devices`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ ids: deviceIds }),
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 403) {
          throw {
            status: 403,
            message:
              data.message ||
              "Acceso denegado: no tienes permisos de administrador.",
          };
        }
        throw {
          status: response.status,
          message: data.message || response.statusText,
        };
      }

      return data;
    } catch (error) {
      console.error("Error al intentar eliminar dispositivos:", error);
      throw error;
    }
  },

  async getPocStatus() {
    const url = `${baseURL}/api/device_poc_status`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`Error en la petición: ${response.statusText}`);
    }
    const data = await response.json();
    return data.data;
  },

  async actualizarUsuario(datosUsuario) {
    try {
      const response = await fetch(`${baseURL}/api/update_user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify(datosUsuario),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.error || data.message || "Error al actualizar el usuario"
        );
      }

      return data; // Se espera {message, user, token}
    } catch (error) {
      console.error("Error en la actualización:", error);
      throw error;
    }
  },

  async uploadProfileImage(formData) {
    console.log(formData);
    const url = `${baseURL}/api/upload_profile_image`;
    const response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Error al subir la imagen");
    }
    return await response.json();
  },

  async getProfileImage() {
    const url = `${baseURL}/api/profile_image`;
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Error al obtener la imagen de perfil"
      );
    }
    return await response.json(); // Se espera { url: "..." }
  },

  async getUser() {
    const url = `${baseURL}/api/get_user`;
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Error al obtener datos del usuario");
    }
    return await response.json(); // Se espera { user: { username, foto_perfil, ... } }
  },

  /**
   * Obtiene los detalles de un dispositivo en base a la MAC ficticia.
   * Se espera que la respuesta incluya: apodo, tipo_dispositivo, estado, etiqueta, lat y lon.
   */
  async getDeviceDetails(mac) {
    const url = `${baseURL}/api/device_details?mac=${encodeURIComponent(mac)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(
        `Error al obtener detalles del dispositivo: ${response.statusText}`
      );
    }
    return await response.json();
  },

  /**
   * Actualiza los detalles de un dispositivo.
   * Se envía la información al endpoint de Lambda, incluyendo el campo 'etiqueta'.
   */
  async updateDeviceDetails(deviceData) {
    try {
      // 1) Construir el payload básico
      const payload = {
        mac_serie: deviceData.mac_serie,
        tipo_dispositivo: deviceData.tipo_dispositivo,
        apodo: deviceData.apodo,
        estado: deviceData.estado,
        etiqueta: deviceData.etiqueta,
      };

      // 2) Solo verificar si es admin *si el tipo es Reader*
      if (deviceData.tipo_dispositivo === "Reader") {
        const isAdmin = await checkAdminStatus();

        if (!isAdmin) {
          throw new Error(
            "Solo los administradores pueden actualizar lectores."
          );
        }

        // 3) Añadir lat/lon si existen
        if (deviceData.lat != null && deviceData.lon != null) {
          payload.lat = deviceData.lat;
          payload.lon = deviceData.lon;
        }
      }

      // 4) Enviar a Flask
      const flaskUrl = `${baseURL}/api/update_device_details`;
      const response = await fetch(flaskUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error al actualizar el dispositivo: ${errorText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error en updateDeviceDetails:", error);
      throw error;
    }
  },
  async changeDeviceStatus({
    mac_serie,
    apodo,
    nuevo_estado,
    tipo_dispositivo,
    etiqueta,
  }) {
    if (!mac_serie) throw new Error("Falta mac_serie");
    const payload = {
      mac_serie,
      apodo: apodo && String(apodo).trim() ? apodo : "-", // requerido por tu endpoint
      estado: nuevo_estado, // el cambio
      tipo_dispositivo: tipo_dispositivo || "",
      etiqueta: etiqueta || "",
    };
    console.log("Payload para cambiar estado:", payload);

    const res = await fetch(`${baseURL}/api/update_device_details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });
    if (!res.ok)
      throw new Error(
        `Error cambiando estado: ${res.status} - ${await res.text()}`
      );
    return await res.json();
  },
  async changeDeviceApodo(input) {
    const {
      mac_serie,
      // acepta ambos nombres desde la vista
      apodo: apodoDesdeVista,
      nuevo_apodo: apodoDesdeVista2,
      estado,
      tipo_dispositivo,
      etiqueta,
    } = input || {};

    if (!mac_serie) throw new Error("Falta mac_serie");

    // prioriza 'nuevo_apodo'; si no viene, usa 'apodo'
    const apodo = (apodoDesdeVista2 ?? apodoDesdeVista ?? "").toString().trim();
    if (!apodo) throw new Error("Falta apodo");

    const payload = {
      mac_serie,
      apodo, // <-- ya no va vacío
      // opcionales: si no quieres tocar Valor al cambiar apodo, puedes omitir 'estado'
      estado: estado ?? "",
      tipo_dispositivo: tipo_dispositivo ?? "",
      etiqueta: etiqueta ?? "",
    };

    const res = await fetch(`${baseURL}/api/update_device_details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`Error cambiando apodo: ${res.status} - ${txt}`);
    }
    return await res.json();
  },
  /*async getIncidencias() {
    const url = `${baseURL}/api/get_incidencias`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Error al obtener incidencias: ${response.statusText}`);
    }

    return await response.json(); // Devuelve { data: [...] }
  },*/
  async getResumenIncidencias() {
    const url = `${baseURL}/api/get_resumen_incidencias`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error al obtener resumen de incidencias: ${response.status} - ${errorText}`
      );
    }

    return await response.json();
  },
  async downloadAllEventosExcel(filters = {}) {
    console.log("Descargando eventos con filtros:", filters);
    const url = new URL(`${baseURL}/api/export_eventos_excel`);
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value.trim().length > 0) {
        url.searchParams.append(key, value.trim());
      }
    });

    const response = await fetch(url.toString(), {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error al descargar Excel: ${response.status} - ${errorText}`
      );
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = "eventos_completo.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
  },
  async setImpacto(payload) {
    const response = await fetch(`${baseURL}/api/set_impacto`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // si usas cookies o sesión
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error?.message || "Error al actualizar impacto");
    }

    return response.json();
  },
  async getIncidencias({ start_date, end_date } = {}) {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const response = await fetch(`${baseURL}/api/get_incidencias?${params}`, {
      method: "GET",
      credentials: "include",
    });
    return await response.json();
  },
  async cambiarContrasena(data) {
    const response = await fetch(`${baseURL}/api/change_password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Error al cambiar la contraseña");
    }

    return await response.json();
  },
  async getUsuarios() {
    const res = await fetch(`${baseURL}/api/usuarios`, {
      credentials: "include",
    });
    if (!res.ok) throw await res.json();
    return await res.json();
  },

  async crearUsuario(data) {
    const res = await fetch(`${baseURL}/api/usuarios`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(data),
    });
    if (!res.ok) throw await res.json();
    return await res.json();
  },

  async updateUsuario(usuario) {
    const res = await fetch(`${baseURL}/api/usuarios/${usuario.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(usuario),
    });
    if (!res.ok) throw await res.json();
    return await res.json();
  },

  async deleteUsuario(id) {
    const res = await fetch(`${baseURL}/api/usuarios/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!res.ok) throw await res.json();
    return await res.json();
  },
  async getEmpresas() {
    const res = await fetch(`${baseURL}/api/empresas`, {
      credentials: "include",
    });
    if (!res.ok) throw await res.json();
    return await res.json();
  },
  async snakeGetHighScores({ scope = "global", limit = 50 } = {}) {
    const qs = new URLSearchParams({ scope, limit });
    const res = await fetch(
      `${baseURL}/api/snake/highscores?${qs.toString()}`,
      {
        method: "GET",
        credentials: "include",
      }
    );
    if (!res.ok) throw new Error(`GET highscores failed ${res.status}`);
    return res.json();
  },

  async snakePostHighScore(points) {
    const res = await fetch(`${baseURL}/api/snake/highscores`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ points }),
    });
    if (!res.ok) throw new Error(`POST highscore failed ${res.status}`);
    return res.json();
  },
  checkAdminStatus,
};
